import { render, staticRenderFns } from "./SearchTableHeaderSorting.vue?vue&type=template&id=0e805a23&scoped=true&"
import script from "./SearchTableHeaderSorting.vue?vue&type=script&lang=ts&"
export * from "./SearchTableHeaderSorting.vue?vue&type=script&lang=ts&"
import style0 from "./SearchTableHeaderSorting.vue?vue&type=style&index=0&id=0e805a23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e805a23",
  null
  
)

export default component.exports